import { logger } from "../core/logger";

/*
class ProductSellingPlans extends HTMLElement {
  connectedCallback() {
    logger.info("SellingPlans", "connected");

    this.addEventListener("change", this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onChange);
  }

  onChange = (event) => {
    const input = event.target.closest('input[type="radio"][data-radio-type]');
    if (!input) return;

    if (input.dataset.radioType === "one_time_purchase") {
      publish(THEME_EVENTS.sellingPlanSelected, {
        data: { sellingPlanId: null },
      });
      return;
    }

    if (input.dataset.radioType === "selling_plan") {
      const sellingPlanId = input.dataset.sellingPlanId;
      if (!sellingPlanId) return;

      publish(THEME_EVENTS.sellingPlanSelected, {
        data: { sellingPlanId },
      });
    }
  };
}
*/

class ProductSellingPlans extends HTMLElement {
  connectedCallback() {
    this.form = this.closest("form");
    if (!this.form) return;

    // ✅ input EXISTANT dans le form (Shopify)
    this.sellingPlanInput = this.form.querySelector(
      'input[name="selling_plan"]',
    );

    if (!this.sellingPlanInput) {
      logger.error(
        "SellingPlan",
        'input[name="selling_plan"] not found in form',
      );
      return;
    }

    this.addEventListener("change", this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onChange);
  }

  syncInitialState() {
    const checked = this.querySelector(
      'input[type="radio"][data-radio-type]:checked',
    );

    if (!checked) return;

    // Simule exactement le comportement d’un change utilisateur
    this.onChange({ target: checked });
  }

  onChange = (event) => {
    const input = event.target.closest('input[type="radio"][data-radio-type]');
    if (!input) return;

    if (input.dataset.radioType === "one_time_purchase") {
      logger.info("SellingPlan", "user selected ONE TIME PURCHASE");

      // 🔥 IMPORTANT : on enlève selling_plan du form
      this.sellingPlanInput.value = "";
      this.sellingPlanInput.removeAttribute("value");

      return;
    }

    if (input.dataset.radioType === "selling_plan") {
      const sellingPlanId = Number(input.dataset.sellingPlanId);
      if (!sellingPlanId) return;

      logger.info("SellingPlan", "user selected SUBSCRIPTION", {
        sellingPlanId,
      });

      // 🔥 IMPORTANT : on écrit DANS LE FORM
      this.sellingPlanInput.value = String(sellingPlanId);
    }
  };
}
if (!customElements.get("product-selling-plans")) {
  customElements.define("product-selling-plans", ProductSellingPlans);
}
